import React, { useEffect, useState } from 'react';
import './airplane.css';
import Note from '../common/Note';

const AirplaneBody = ({ flight, onSelectSeat, selectedSeat, labels }) => {
  const [ModalOpen, setModalOpen] = useState('');
  const seatLabels = ['A', 'B', 'C', 'D', 'E', 'F'];

  const selectSeat = (seat) => {
    if (seat.note) {
      setModalOpen(seat.note);
    }
    onSelectSeat([...selectedSeat, { seat: seat, seatLabel: seat.column, rowNumber: seat.row }]);
  };

  const deleteSeat = (seatDeleted) => {
    const seats = selectedSeat.filter((s) => s.seat.id !== seatDeleted.id);
    onSelectSeat(seats);
  };

  const isSelected = (seat) => {
    return selectedSeat.some((s) => s.seat.id === seat.id);
  };

  const getSeatClass = (seat) => {
    if (seat.is_available === false) return 'seat-btn seat-taken';
    if (isSelected(seat)) return 'seat-btn seat-selected';
    if (seat.is_emergency && seat.status) return 'seat-btn seat-emergency';
    if (seat.is_business===true && seat.status) return 'seat-btn seat-business';

    if (seat.status === 1 || seat.status === true) {
      if (seat.note) return 'seat-btn seat-xl';
      return 'seat-btn seat-available';
    }
    if (seat.seat_state === "booked" || seat.seat_state === "blocked" || seat.is_available == false) {
      if (seat.note) return 'seat-btn seat-not-available';
      return 'seat-btn seat-taken';
    }
    return 'seat-btn seat-taken';
  };

  const isSeatClickable = (seat) => {
    if (seat.is_available === false) return false;
    if (isSelected(seat)) return true;
    if (seat.seat_state === "booked" || seat.seat_state === "blocked" || seat.is_available == false) {
      return !!seat.note; // not-available with note can show modal
    }
    return true;
  };

  const handleSeatClick = (seat) => {
    if (seat.is_available === false) return;
    if (isSelected(seat)) {
      deleteSeat(seat);
    } else if (seat.seat_state === "booked" || seat.seat_state === "blocked" || seat.is_available == false) {
      if (seat.note) setModalOpen(seat.note);
    } else {
      selectSeat(seat);
    }
  };

  // Get total rows from labels
  const totalRows = labels['A']?.length || 0;

  const isEmergencyRow = (rowIdx) =>
    ['A', 'B', 'C', 'D', 'E', 'F'].some(
      (col) => labels[col]?.[rowIdx]?.is_emergency === true
    );

  return (
    <div className="airplane-wrapper">
      <Note ModalOpen={ModalOpen} HandleClose={() => setModalOpen('')} />

      <div className="airplane-container">
        {/* <img src="/assets/pb.png" alt="Airplane" className="airplane-bg-img" /> */}
        <img
          src={`${process.env.PUBLIC_URL}/assets/j7gVM2.png`}
          alt="Airplane"
          className="airplane-bg-img"
        />
        {/* Seats overlay */}
        <div className="seats-overlay">
          {/* Column headers */}
          <div className="seats-header">
            <div className="row-number-spacer"></div>
            <div className="seat-group-left">
              {seatLabels.slice(0, 3).map((label) => (
                <div key={label} className="col-label">{label}</div>
              ))}
            </div>
            <div className="aisle"></div>
            <div className="seat-group-right">
              {seatLabels.slice(3, 6).map((label) => (
                <div key={label} className="col-label">{label}</div>
              ))}
            </div>
          </div>

          {/* Seat rows */}
          <div className="seats-body">
            {Array.from({ length: totalRows }, (_, rowIdx) => {
              const rowNum = rowIdx + 1;
              const emergency = isEmergencyRow(rowIdx);
              return (
                <React.Fragment key={rowNum}>
                  {emergency && (
                    <div className="emergency-exit-indicator">
                      <div className="emergency-spacer"></div>
                      <div className="emergency-arrow-left">&#8592;Emergency EXIT</div>
                      <div className="emergency-aisle-gap"></div>
                      <div className="emergency-arrow-right">Emergency EXIT &#8594;</div>
                    </div>
                  )}
                  <div className={`seat-row${emergency ? ' seat-row-emergency' : ''}`}>
                    <div className="row-number">{rowNum}</div>
                    <div className="seat-group-left">
                      {['A', 'B', 'C'].map((col) => {
                        const seat = labels[col]?.[rowIdx];
                        if (!seat) return <div key={col} className="seat-btn seat-empty"></div>;
                        const seatClass = getSeatClass(seat);
                        const clickable = isSeatClickable(seat);
                        return (
                          <button
                            key={seat.id}
                            className={seatClass}
                            onClick={() => clickable && handleSeatClick(seat)}
                            disabled={!clickable}
                            title={`${seat.code}${seat.is_emergency ? ' (Emergency)' : ''}${seat.note ? ' - ' + seat.note : ''}`}
                          >
                            {/* <span className="seat-code">{seat.code}</span> */}
                          </button>
                        );
                      })}
                    </div>
                    <div className="aisle"></div>
                    <div className="seat-group-right">
                      {['D', 'E', 'F'].map((col) => {
                        const seat = labels[col]?.[rowIdx];
                        if (!seat) return <div key={col} className="seat-btn seat-empty"></div>;
                        const seatClass = getSeatClass(seat);
                        const clickable = isSeatClickable(seat);
                        return (
                          <button
                            key={seat.id}
                            className={seatClass}
                            onClick={() => clickable && handleSeatClick(seat)}
                            disabled={!clickable}
                            title={`${seat.code}${seat.is_emergency ? ' (Emergency)' : ''}${seat.note ? ' - ' + seat.note : ''}`}
                          >
                            {/* <span className="seat-code">{seat.code}</span> */}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AirplaneBody;



